export interface LinkRequest {
    managedId: number;
    productId: number;
}

export interface MergeRequest {
    keepId: number;
    deleteId: number;
    name: MergeValueKeep;
    departmentId: MergeValueKeep;
    subdepartmentId: MergeValueKeep;
    manufacturerId: MergeValueKeep;
    supplierId: MergeValueKeep;
    cartonSize: MergeValueKeep;
    minOrderQty: MergeValueKeep;
    minStockLevel: MergeValueKeep;
    maxStockLevel: MergeValueKeep;
    gstCode: MergeValueKeep;
    active: MergeValueKeep;
    ethical: MergeValueKeep;
    locked: MergeValueKeep;
    costEx: MergeValueKeep;
    baseSellPrice: MergeValueKeep;
    rRP: MergeValueKeep;
    additionalOrderInformation: MergeValueKeep;
    stockGroupIds: MergeValueKeep;
}

export enum MergeValueKeep {
    Keep,
    Delete
}